define([
	"dojo/_base/declare",
	"csi/action/_ImageBrowseMixin",
	"csi/heading/AttributeController"
], function(declare,_ImageBrowseMixin,AttributeController) {

	return declare([AttributeController, _ImageBrowseMixin], {
		bOneImage: false,
		
		process: function() {
			// summary: store selected image as new value and cache for viewing
			this.newValue = this._imageUrls;
			this.inherited(arguments);
		},
		
		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: save selected image to attribute
			return this._toWriterImages(id, type);
		}
	});
});